const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20a%20spotlight%20on%20an%20empty%20stage%20with%20red%20velvet%20curtains%2C%20dramatic%20theater%20atmosphere%2C%20warm%20crimson%20lighting%2C%20mysterious%20shadow%20play%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people&width=800&height=420&seq=carousel-focus-01&orientation=landscape",
    tag: '本周焦点',
    title: '顶流恋情连环爆：多位当红艺人私生活遭深扒',
    desc: '本周娱乐圈接连爆出多起顶流艺人恋情，从深夜密会到同款穿搭，吃瓜群众忙不过来了。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20a%20backstage%20corridor%20with%20warm%20amber%20light%20streaming%20through%20doorways%2C%20long%20shadows%2C%20cinematic%20tension%2C%20editorial%20photography%20style%2C%20no%20text%20no%20faces%20no%20people&width=800&height=420&seq=carousel-focus-02&orientation=landscape",
    tag: '深度追踪',
    title: '某选秀节目黑幕调查：从投票数据到合约条款',
    desc: '持续追踪某热门选秀节目的暗箱操作疑云，从异常投票数据到不公平合约，逐层揭开选秀产业链的灰色地带。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20atmospheric%20street%20scene%20at%20night%20with%20warm%20neon%20red%20glow%20on%20wet%20pavement%2C%20cinematic%20noir%20style%2C%20dramatic%20contrast%2C%20mysterious%20urban%20vibe%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people&width=800&height=420&seq=carousel-focus-03&orientation=landscape",
    tag: '月度盘点',
    title: '七月黑料大盘点：哪些瓜最值得回味？',
    desc: '回顾七月份那些让全网沸腾的劲爆爆料，从网红翻车到综艺互撕，一场都不落下的吃瓜月报。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20moody%20office%20scene%20with%20scattered%20documents%20and%20a%20glowing%20computer%20screen%2C%20warm%20desk%20lamp%20light%2C%20investigative%20journalism%20atmosphere%2C%20dramatic%20shadows%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people&width=800&height=420&seq=carousel-focus-04&orientation=landscape",
    tag: '独家专题',
    title: '经纪公司大洗牌：艺人合约背后的权力游戏',
    desc: '深度解析近期多家经纪公司人事变动背后的利益纠葛，多位艺人面临职业生涯的重大转折点。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20of%20multiple%20glowing%20smartphone%20screens%20floating%20in%20darkness%2C%20warm%20red%20and%20amber%20glow%2C%20social%20media%20abstract%20concept%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20no%20text%20no%20faces%20no%20people&width=800&height=420&seq=carousel-focus-05&orientation=landscape",
    tag: '现象观察',
    title: '网红经济泡沫：从千万粉丝到一夜凉凉有多远？',
    desc: '随着直播带货行业进入深水区，网红翻车事件频发。我们梳理了今年以来最具代表性的网红塌房案例，探讨背后的行业乱象。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选深度专题报道，不止吃瓜更懂背后的故事
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`bg-background-50 border border-background-200 rounded-lg overflow-hidden group cursor-pointer hover:border-primary-200 transition-colors ${
                i === 0 ? 'lg:col-span-3 lg:row-span-2' : 'lg:col-span-2'
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[16/7]' : 'aspect-[16/9]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="inline-block px-2 py-0.5 text-[11px] font-semibold rounded-full bg-primary-500 text-background-50 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className={`font-bold text-background-50 leading-tight mb-1 ${
                    i === 0 ? 'text-lg md:text-xl' : 'text-sm'
                  }`}>
                    {item.title}
                  </h3>
                  {i === 0 && (
                    <p className="text-xs md:text-sm text-background-50/80 leading-relaxed mt-2 line-clamp-2">
                      {item.desc}
                    </p>
                  )}
                </div>
              </div>
              {i !== 0 && (
                <div className="p-3 md:p-4">
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}